export const userPermissions = {
  // Bit 0: every system admin has it (admin_api's BASIC, ant's "Read Only" role).
  BASIC: 'basic',
  PARTNER: 'partner',
  ADMIN: 'admin',
  RENTAL: 'rental',
  RATES: 'rates',
  REFUNDS: 'refunds',
  BANK: 'bank',
  PHYSICAL: 'physical',
  USERS: 'users',
  LOCATIONS: 'locations',
  SUPPORT: 'support',
  MAINTENANCE: 'maintenance',
  MEMBERSHIPS: 'memberships',
  DOCUMENTATION: 'documentation',
};
